// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-modal::part(content) {\n    --background: none;\n    --box-shadow: none!important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/map/marker/CustomMarker.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4BAA4B;AAChC","sourcesContent":["ion-modal::part(content) {\n    --background: none;\n    --box-shadow: none!important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
